<div class="container-progress-bar-step">
	<ul id="progressbar_pasos" class="five_pasos">
		<li *ngFor="let item of items" [ngClass]="{ active_paso: item.active }">
			<div class="icon_step"><img [src]="item.src" [alt]="item.alt" /></div>
			<strong>{{ item.title }}</strong>
		</li>
	</ul>
</div>
